import React from 'react';
import { translate } from 'react-i18next';
import { ScrollView, StyleSheet, Text, View } from 'react-native';
import { Button, ButtonTypes } from '../../components';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';
import { default as BodyscaleInfo } from './bodyscale-info';
import {BodyscaleAccordionSectionInfo} from './bodyscale-info';

const BodyscaleStartScanComponent = ({ t, startScan, bodyComposition, showBodyGroups, athleteMode, removeScale }) => {
  return (
    <View style={{ flex: 1 }}>
      <ScrollView contentContainerStyle={styles.scrollContainer}>
        <View style={styles.container}>
          <View style={styles.textContainer}>
            <Text style={styles.heading}>Tap Continue <Text style={{...styles.heading, textDecorationLine: 'underline'}}>before</Text> you step barefoot onto the scale.</Text>
            <Text style={styles.subHeading}>{t('smartScaleRequired')}</Text>
          </View>
          <BodyscaleInfo
            containerStyle={{ marginTop: 0 }}
            activeSection={null}
            bodyComposition={bodyComposition}
            athleteMode={athleteMode}
            showBodyGroups={showBodyGroups}
            bodyscaleAccordionSections={[
              BodyscaleAccordionSectionInfo.BODYTYPE,
              BodyscaleAccordionSectionInfo.BODYCONDITIONING,
              BodyscaleAccordionSectionInfo.INSTRUCTIONS,
            ]}
          />
        </View>
      </ScrollView>
      <Button
        title={t('dontHaveScale')}
        fontColor={Theme.PRIMARY}
        buttonType={ButtonTypes.OUTLINE}
        containerStyle={styles.dontHaveScale}
        onPress={removeScale}
      />
      <Button title={t('continueToScan')} fontColor={Theme.WHITE} onPress={startScan}/>
    </View>
  );
};

const styles = StyleSheet.create({
  scrollContainer: {
    flexGrow: 1,
  },
  container: {
    flex: 1,
    marginBottom: defaultScale(25),
    justifyContent: 'flex-end',
  },
  textContainer: {
    flex: 1,
    marginVertical: defaultScale(30),
    justifyContent: 'center',
    alignItems: 'center',
  },
  heading: {
    ...Theme.textStyle.heading,
    maxWidth: defaultScale(300),
    marginBottom: defaultScale(15),
    textAlign: 'center',
  },
  subHeading: {
    ...Theme.textStyle.bodyCopyReg,
    maxWidth: defaultScale(300),
    color: Theme.GREY_DARK_MEDIUM,
    textAlign: 'center',
  },
  dontHaveScale: {
    marginBottom: defaultScale(14),
  },
});

export const BodyscaleStartScan = translate(['bodyscan'])(
  BodyscaleStartScanComponent,
);
